import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import CustomLightboxContainer from './CustomLightboxContainer';

const StyledIframe = styled.iframe`
  width: 70vw;
  height: 80vh;
  user-select: all;
  pointer-events: all;
  background-color: black;
`;

const IframeLightbox = ({ src, ...props }) => (
  <CustomLightboxContainer {...props}>
    <StyledIframe src={src} allow="fullscreen" />
  </CustomLightboxContainer>
);

IframeLightbox.propTypes = {
  src: PropTypes.string.isRequired,
};

export default IframeLightbox;
